import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { DH_COLOR_THEMES, DhColorTheme, LayoutService } from "./service/app.layout.service";
import { AuthService } from '../services/auth.service';
import { AppSearchDialogComponent } from './app.search-dialog.component';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html'
})
export class AppTopBarComponent implements OnInit {

    @ViewChild('menubutton') menuButton!: ElementRef;

    @ViewChild('topbarmenubutton') topbarMenuButton!: ElementRef;

    @ViewChild('topbarmenu') menu!: ElementRef;

    @ViewChild('search') search!: AppSearchDialogComponent;

    user = { name: '', email: '' };
    initials = '';
    userItems: MenuItem[] = [];
    shortcut = /Mac|iPhone|iPad/.test(navigator.platform) ? '⌘K' : 'Ctrl K';

    constructor(public layoutService: LayoutService, private authService: AuthService, private router: Router) { }

    ngOnInit(): void {
        this.user = this.authService.currentUser();
        this.initials = this.user.name.split(/[\s.]+/).filter(Boolean).slice(0, 2).map((p) => p[0].toUpperCase()).join('') || 'A';
        this.buildUserItems();
    }

    private buildUserItems(): void {
        const current = this.layoutService.colorTheme;
        this.userItems = [
            { label: this.user.name, disabled: true, styleClass: 'font-semibold' },
            ...(this.user.email ? [{ label: this.user.email, disabled: true }] : []),
            { separator: true },
            { label: 'Colores del panel', disabled: true, styleClass: 'dh-menu-group' },
            ...DH_COLOR_THEMES.map((t) => ({
                label: t.label,
                icon: t.id === current ? 'pi pi-check' : 'pi pi-circle-fill',
                styleClass: 'dh-theme-option dh-theme-' + t.id + (t.id === current ? ' is-current' : ''),
                command: () => this.setTheme(t.id),
            })),
            { separator: true },
            { label: 'Cerrar sesión', icon: 'pi pi-sign-out', command: () => this.logout() },
        ];
    }

    setTheme(theme: DhColorTheme): void {
        this.layoutService.setColorTheme(theme);
        this.buildUserItems();
    }

    // ⌘K / Ctrl+K abre la búsqueda global desde cualquier pantalla.
    @HostListener('document:keydown', ['$event'])
    onKey(e: KeyboardEvent): void {
        if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
            e.preventDefault();
            this.openSearch();
        }
    }

    openSearch(): void { this.search?.open(); }

    logout(){
        this.authService.logout();
        this.router.navigate(['auth/login']);
    }
}
